import config from "../../assets/js/conf/config";
import request from "../../assets/js/utils/request";

/** 关联弹窗回显 */
export function getRelativeInfo(data) {
	return request.get(config.baseApiB + "/api/v1/wxshop/relative/info", data || {})
}

/** 同步并获取 1688 规格 */
export function getAlibabaSkuInfo(data) {
	return request.get(config.baseApiB + "/api/v1/wxshop/relative/alibaba-sku", data || {})
}

/** 提交永久/临时关联 */
export function postRelativeSave(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/relative/save", data || {})
}

/** 查询永久关联 */
export function getRelativeQuery(data) {
	return request.get(config.baseApiB + "/api/v1/wxshop/relative/query", data || {})
}

/** 关联历史 */
export function getRelativeHistory(data) {
	return request.get(config.baseApiB + "/api/v1/wxshop/relative/history", data || {})
}

/** 搜同款图搜 */
export function postImageSearch(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/relative/image-search", data || {})
}

/** 图搜过滤条件 */
export function getFilterTypes(data) {
	return request.get(config.baseApiB + "/api/v1/wxshop/relative/filter-types", data || {})
}

/** 同步微店商品到本地 */
export function postSyncWxProduct(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/relative/sync-wx-product", data || {})
}
